var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3430_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.77187C16 1.06019 15.4231 0.483276 14.7114 0.483276H1.28859C0.576913 0.483276 0 1.06019 0 1.77187V14.2282C0 14.9399 0.576913 15.5168 1.28859 15.5168H14.7114C15.4231 15.5168 16 14.9399 16 14.2282V1.77187ZM4.88591 2.09401H7.19463V3.91952H4.88591V2.09401ZM3.27517 13.9061H1.61074V12.0806H3.27517V13.9061ZM3.27517 3.91952H1.61074V2.09401H3.27517V3.91952ZM7.19463 13.9061H4.88591V12.0806H7.19463V13.9061ZM6.60403 9.48773V6.51232C6.60403 6.06937 6.91909 5.9055 7.28966 6.14814L9.45004 7.55871C9.82062 7.80134 9.82362 8.19839 9.45305 8.44108L7.28816 9.85192C6.91758 10.0946 6.60403 9.93069 6.60403 9.48773ZM11.1141 13.9061H8.80537V12.0806H11.1141V13.9061ZM11.1141 3.91952H8.80537V2.09401H11.1141V3.91952ZM14.3893 13.9061H12.7248V12.0806H14.3893V13.9061ZM14.3893 3.91952H12.7248V2.09401H14.3893V3.91952Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3430_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.c16ef299224cee7ed46e9265169d5308.svg";
export { ForwardRef as ReactComponent };